module.exports = __webpack_public_path__ + "img/iphone.345c6602.png";